import * as React from 'react';

import Logo from '../components/Logo.js'
import Container from '@mui/material/Container';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
function Copyright(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '} {new Date().getFullYear()}{' '}
        <Link color="inherit" target="_blank" href="https://ingeniosolution.it/">
          Ingenio Solution S.a.s. di Fiumanò Attilio
        </Link>
        
      </Typography>
    );
  }

  export default function Footer(props) {
    return (
        <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        
        <Container  align="center"  maxWidth="sm">
           
          <Logo width={250}/>
          <Copyright  />
        </Container> 
        
      </Box>);
  }